import { render, staticRenderFns } from "./orgao.vue?vue&type=template&id=5bf9a88a&scoped=true"
import script from "./orgao.vue?vue&type=script&lang=js"
export * from "./orgao.vue?vue&type=script&lang=js"
import style0 from "./orgao.vue?vue&type=style&index=0&id=5bf9a88a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf9a88a",
  null
  
)

export default component.exports